import React from 'react';
import '../../style.css';

const ProgressBar = ({ currentStep }) => {
  const stepLabels = ['Personal Details', 'Professional Details', 'Agreements and Terms']; // Labels for each step

  const getStepClass = (step) => {
    if (step < currentStep) return 'step completed';
    if (step === currentStep) return 'step active';
    return 'step';
  };

  return (
    <div className="progress-bar-container">
      <div className="progress-track"></div>
      <div className="progress" style={{ width: `${(currentStep - 1) * 50}%` }}></div>
      {stepLabels.map((label, index) => (
        <div key={index + 1} className={getStepClass(index + 1)}>
          <div className="circle">{index + 1 < currentStep ? <span>&#10003;</span> : index + 1}</div>
          <span className="label">{label}</span>
        </div>
      ))}
    </div>
  );
};

export default ProgressBar;
